import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleToggleNav = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div id="header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-dark">
                    {/* Mobile Logo */}
                    <a className="navbar-brand d-block d-lg-none" href="#">
                        <div className="brand-logo">
                            <Link to="/">
                                <img
                                    src="../assets/images/icon/logo13.png"
                                    alt="Logo"
                                    className="img-fluid lazyload"
                                />
                            </Link>
                        </div>
                    </a>

                    {/* Toggle Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={handleToggleNav}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Links */}
                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarSupportedContent">
                        {/* Left Menu */}
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link to="/" className="nav-link menu-title">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/About" className="nav-link menu-title">About Us</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Experiences" className="nav-link menu-title">Experiences</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Accommodation" className="nav-link menu-title">Accommodation</Link>
                            </li>
                        </ul>

                        {/* Center Logo */}
                        <a className="navbar-brand d-none d-lg-block" href="#">
                            <div className="brand-logo">
                                <Link to="/">
                                    <img
                                        src="../assets/images/icon/logo13.png"
                                        alt="Logo"
                                        className="img-fluid lazyload"
                                        style={{ height: 100, width: 180 }}
                                    />
                                </Link>
                            </div>
                        </a>

                        {/* Right Menu */}
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link to="/Dining" className="nav-link menu-title">Dining</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Orchid" className="nav-link menu-title">The Orchard</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Packages" className="nav-link menu-title">Package</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Gallery" className="nav-link menu-title">Gallery</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Profilelogin" className="nav-link menu-title">
                                    <i className="fas fa-user"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Header;
